// removed by extract-text-webpack-plugin
module.exports = {"inputWrapper":"inputWrapper___2w-n3","vpHiddenInput":"vpHiddenInput___3VK00","vpBadgeContainer":"vpBadgeContainer___ZKIi9","vpCopyTranscriptionButton":"vpCopyTranscriptionButton___1nRt8","vpCopyTranscriptionIcon":"vpCopyTranscriptionIcon___3a9qs","vpRelativeWrapper":"vpRelativeWrapper___1dkTc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HookFormInputs/InputWrapper.module.less
// module id = 3784
// module chunks = 33